<template>
  <div class="bg-primary-dark text-zinc-50 p-6 lg:p-12 flex flex-wrap gap-6 justify-between items-center rounded-2xl">
    <div class="flex flex-col">
      <p class="text-4xl">
        {{ data[0]?.topic }}
      </p>
      <p class="text-primary-green mb-3">
        {{ data[0]?.lead }}
      </p>
      <ButtonGeneral
        :url="data[0]?.link"
        text="Register"
        class="self-start"
      />
    </div>
    <div class="bg-primary  p-3 rounded-2xl">
      <p class="font-bold">
        {{ useDateFormat(data[0]?.start, 'H:mm') }} - {{ useDateFormat(data[0]?.end, 'H:mm') }}
      </p>
      <p>{{ useDateFormat(data[0]?.start, 'DD/MM/YYYY') }}</p>
      <p>{{ useDateFormat(data[0]?.start, 'z') }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const limit = ref(100)
const sort = ref({ start: 1, $numeric: true })
// Use ISO string for "now"
const now = new Date().toISOString()

const where = ref({
  start: { $gt: now as unknown as number },
})

const { data } = await useAsyncData('collections-all-upcoming-journals',
  () => queryContent<JournalClubSession>('/sessions').limit(limit.value).where(where.value).sort(sort.value).find(),
  { transform: data => correctAssetRoutes(data),
    watch: [limit, sort],
  },
)

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
</script>

<style scoped>

</style>
